export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export function daysLeft(iso) {
  if (!iso) return null;
  const diff = new Date(iso) - new Date();
  if (isNaN(diff)) return null;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function fmtEuro(n) {
  const v = Number(n || 0);
  return v.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
}

export function scoreColor(score) {
  if (score >= 85) return "text-emerald-600 bg-emerald-50 border-emerald-200";
  if (score >= 65) return "text-blue-700 bg-blue-50 border-blue-200";
  return "text-amber-600 bg-amber-50 border-amber-200";
}
